import React, { createContext, useState , useEffect } from 'react';

// Create context
export const SchoolSignupContext = createContext();

// Provider component
// export const SchoolSignupProvider = ({ children }) => {
//   const [signupData, setSignupData] = useState({
//     schoolName: '',
//     schoolId: '',
//     schoolCode: '',
//     email: '',
//     password: '',
//   });


  export const SchoolSignupProvider = ({ children }) => {
    const [signupData, setSignupData] = useState(() => {
      const saved = localStorage.getItem('signupData');
      return saved
        ? JSON.parse(saved)
        : {
            schoolName: '',
            schoolId: '',
            schoolCode: '',
            email: '',
            password: '',
            schoolType: '',
          };
    });

    const [signupDataSession, setSignupDataSession] = useState(() => {
    const saved = sessionStorage.getItem('signupDataSession');
    return saved
      ? JSON.parse(saved)
      : {
          schoolName: '',
          schoolId: '',
          schoolCode: '',
          email: '',
          password: '',
          schoolType: '',
        };
      });  
    // Save to localStorage whenever signupData changes
    useEffect(() => {
      console.log("signupData changed:", signupData);
      localStorage.setItem('signupData', JSON.stringify(signupData));
    }, [signupData]);
  
    useEffect(() => {
      console.log("signupDataSession changed:", signupDataSession);
    sessionStorage.setItem('signupDataSession', JSON.stringify(signupDataSession));
  }, [signupDataSession]);
// reset 
    // setSignupData({
    //   schoolName: '',
    //   schoolId: '',
    //   schoolCode: '',
    //   email: '',
    //   password: '',
    // });
    // localStorage.removeItem('signupData');
    
  return (
    <SchoolSignupContext.Provider value={{ signupData, setSignupData,signupDataSession, setSignupDataSession }}>
      {children}
    </SchoolSignupContext.Provider>
  );
};
